import React from "react";

interface UploadImagePreviewProps {
    preview: string;
}

function UploadedImagePreview({preview}: UploadImagePreviewProps) {
    if (preview !== "") {
        return (
            <div>
                <img
                    alt={"preview of guitar to predict"}
                    width={200}
                    className={"shadow-2xl object-contain"}
                    src={preview}
                />
            </div>
        );
    }
    return (<span></span>);
}

export default UploadedImagePreview;